import { Fragment } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';

import type { AddonItem } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import AddonCheckbox from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/components/Form/components/AddonCheckbox';

export const TicketAddons = ({
  addons = [],
  ticketIndex,
}: {
  addons?: AddonItem[];
  ticketIndex: number;
}) =>
  addons.length > 0 ? (
    <Box mt={5} flexDirection="column" gridColumn="1/3">
      <Box mb={5} font="body-semibold-asphalt">
        {__('Additional Items available')}
      </Box>
      {addons.map((addon, i) => (
        <Fragment
          key={`attendee-${ticketIndex}-addon-${i}`} // Using index plus object id to assure uniqueness
        >
          <Box flexGrow={1} flexDirection="column">
            <AddonCheckbox
              name={`attendees[${ticketIndex}][addons][${i}]`}
              addon={addon}
            />
          </Box>
          {i + 1 < addons.length && <Divider my={3} />}
        </Fragment>
      ))}
    </Box>
  ) : null;
